module.exports = __webpack_public_path__ + "img/ppr-group-systems-buttons-add.b6093d29.svg";